import routes from '../front';
import apiRoutes from '../api';
import url from '@/constants/url';

// Route generator
export const path = (data) => {
  const model = routes[data.name] || null;
  if (!model) throw new Error(`Not found: ${data.name}`);
  let path = `/${model.path}`;
  if (model.parameters) {
    for (const [parameter, value] of Object.entries(model.parameters)) {
      if (data.params[parameter]) {
        // Parameters is defined
        path = path.replace(`:${parameter}`, String(data.params[parameter]));
      } else if (value !== undefined) {
        // Parameter has default
        path = path.replace(`:${parameter}`, String(value));
      } else {
        // Required parameter is not defined
        throw new Error(`parameter ${parameter} is required`);
      }
    }
  }

  return path;
};

export const routePath = (routeName) => routes[routeName]?.path;

export const axiosPath = (data, open = false) => `${url.admin_api}${open ? 'o' : 'u'}/${apiRoutes[data].path}`;
